module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/deduction-details/deduction-details-grid/deduction-details-grid.component.css
// module id = ./src/app/hrms/payroll/deduction-details/deduction-details-grid/deduction-details-grid.component.css
// module chunks = main